import { render, staticRenderFns } from "./HeaderLocaleMobile.vue?vue&type=template&id=63dbae7c&scoped=true&"
import script from "./HeaderLocaleMobile.vue?vue&type=script&lang=js&"
export * from "./HeaderLocaleMobile.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLocaleMobile.vue?vue&type=style&index=0&id=63dbae7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dbae7c",
  null
  
)

export default component.exports